import React from 'react';
import { Spin } from 'antd';
import { StyledButton, StyledButtonLink } from './styles';

export interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'danger' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
  iconOnly?: boolean;
  fullWidth?: boolean;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit';
  title?: string;
  className?: string;
  'aria-label'?: string;
  href?: string;
  download?: boolean | string;
  target?: string;
  rel?: string;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  icon,
  iconOnly = false,
  fullWidth = false,
  children,
  onClick,
  type = 'button',
  title,
  className,
  'aria-label': ariaLabel,
  href,
  download,
  target,
  rel,
}) => {
  const sharedProps = {
    $variant: variant,
    $size: size,
    $iconOnly: iconOnly,
    $fullWidth: fullWidth,
    $loading: loading,
    title,
    className,
    'aria-label': ariaLabel || (iconOnly && title ? title : undefined),
  };

  const content = (
    <>
      {loading && <Spin size="small" />}
      {!loading && icon && icon}
      {!iconOnly && children}
    </>
  );

  if (href) {
    return (
      <StyledButtonLink
        {...sharedProps}
        href={href}
        download={download}
        target={target}
        rel={rel}
      >
        {content}
      </StyledButtonLink>
    );
  }

  return (
    <StyledButton
      {...sharedProps}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
      aria-busy={loading || undefined}
    >
      {content}
    </StyledButton>
  );
};

export default Button;
